import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from "./state.js";
import { getStorage } from "./helper";

import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Form from 'react-bootstrap/Form';
import {
  Routes,
  Route,
  BrowserRouter,
  Link,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import './styles.css';
import Layout from "./layout";
import Login from "./routes/login/index.js";

import Home from "./routes/home";
import PhoneBook from "./routes/phonebook";
import Settings from "./routes/settings";
import Send from "./routes/send";
import ChangePassword from "./routes/change-password";
import Roles from "./routes/roles";
import Users from "./routes/users";
import Colors from "./routes/colors";


import AddPhoneBook from "./modals/addphonebook";
import AddContact from "./modals/addcontact";
import ImportContacts from "./modals/import";
import Templates from "./modals/templates";
import Role from "./modals/role.js";
import User from "./modals/user.js";
import Color from "./modals/color.js";
import PrintContacts from "./modals/print.js";
import GroupReminder from "./modals/reminder.js";

import NiceModal, { ModalDef, useModal } from '@ebay/nice-modal-react';

if (getStorage('token')) {
  useStore.setState({ auth: 1 });
  //setAuth('1');

}
function AuthRoute({ children }) {
  const auth = useStore((state) => state.auth)
  let location = useLocation();

  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}





export default function App() {


  const location = useLocation();
  useEffect(() => {


  }, [location]);
  return (
    <>
      <Routes>

        <Route path="/" element={<Layout />}  >
          <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />
          <Route path="phonebook/:id" element={<AuthRoute><PhoneBook /></AuthRoute>} />
          <Route path="settings" element={<AuthRoute><Settings /></AuthRoute>} />
          <Route path="send" element={<AuthRoute><Send /></AuthRoute>} />
          <Route path="change-password" element={<AuthRoute><ChangePassword /></AuthRoute>} />
          <Route path="roles" element={<AuthRoute><Roles /></AuthRoute>} />
          <Route path="users" element={<AuthRoute><Users /></AuthRoute>} />
          <Route path="colors" element={<AuthRoute><Colors /></AuthRoute>} />



        </Route>
        <Route path="*" element={<NoMatch />} />
        <Route path="/login" element={<Login />} />


      </Routes>
      <ModalDef id="addphonebook" component={AddPhoneBook} />
      <ModalDef id="addcontact" component={AddContact} />
      <ModalDef id="importcontacts" component={ImportContacts} />
      <ModalDef id="templates" component={Templates} />
      <ModalDef id="role" component={Role} />
      <ModalDef id="user" component={User} />
      <ModalDef id="print" component={PrintContacts} />
      <ModalDef id="greeting" component={GroupReminder} />
      <ModalDef id="color" component={Color} />


    </>
  );
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
